import { post } from './common';
export const GetConnectionStatus = () => post('/Services/AmazonBusinessService.asmx/GetConnectionStatus');
export const GetAuthGrantUrl = () => post('/Services/AmazonBusinessService.asmx/GetAuthGrantUrl');
export const Disconnect = () => post('/Services/AmazonBusinessService.asmx/Disconnect');
